import { CommonModule } from '@angular/common';
import { Component, HostListener, inject } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { HeaderComponent } from "../header/header.component";
import { FooterComponent } from "../footer/footer.component";

@Component({
  selector: 'app-system-admin',
  standalone: true,
  imports: [CommonModule, HeaderComponent, FooterComponent, RouterLink],
  templateUrl: './system-admin.component.html',
  styleUrl: './system-admin.component.scss'
})
export class SystemAdminComponent {
  router = inject(Router)
  menuOpen = false;


  viewCompany() {
    this.router.navigate(['/system-admin-dashboard/company'])
  }

  viewBranch() {
    this.router.navigate(['/system-admin-dashboard/branch'])
  }

  viewUsers() {
    this.router.navigate(['/system-admin-dashboard/user'])
  }

  viewSystemAdmin() {
    this.router.navigate(['/system-admin-dashboard/system-settings'])
  }

  openMenu() {
    this.menuOpen = true;
  }
  
  closeMenu() {
    this.menuOpen = false;
  }
 
  toggleMenu() {
    this.menuOpen = !this.menuOpen;
  }
  
  @HostListener('document:click', ['$event'])
  handleClickOutside(event: Event) {
    const target = event.target as HTMLElement;
    if (!target.closest('#au_header_user_menu_toggle')) {
      this.menuOpen = false;
    }
  }

}
